import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListTotalTtcCell } from './emsp-bo-rfid-badge-order-list-total-ttc.cell';
import { EmspBoRfidBadgeOrderListTotalTtcHeader } from './emsp-bo-rfid-badge-order-list-total-ttc.header';

export const EmspBoRfidBadgeOrderListTotalTtcColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['totalTTC']
> = {
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListTotalTtcHeader,
  cell: EmspBoRfidBadgeOrderListTotalTtcCell,
};
